import { get } from "../httpmethods";
import { URL_API } from "../config";

export const RolesAPI = {
    getRoles: async () => {
        return await get(`${URL_API}/roles`);
    }
}
